import React from 'react';

interface RevolutPayIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

export const RevolutPayIcon: React.FC<RevolutPayIconProps> = ({
  width = 24,
  height = 24,
  className,
  style,
}) => {
  return (
    <svg
      aria-label="Revolut Pay"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
    >
      <path
        fill="#0075EB"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.5 14h-7c-.28 0-.5-.22-.5-.5v-7c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v7c0 .28-.22.5-.5.5z"
      />
    </svg>
  );
};

